angular
    .module('app')
    .component('subjectsList', {
        templateUrl: '/templates/pages/subjects/subjectsList/subjectsList.html',
        controller: 'SubjectsListController',
        controllerAs: 'vm',
    });